import { EmptyState, Table } from '@dixa/lib-shared-habla';

export const ConversationsTableRejectedRow = (): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Td colSpan={100}>
        <EmptyState
          title="Failed to load conversations"
          description={
            <>
              If the problem persists, please contact{' '}
              <a
                href="https://www.dixa.com/contact/"
                target="_blank"
                rel="noreferrer"
              >
                support
              </a>
              .
            </>
          }
          icon="exclamation-triangle-filled"
          size="large"
        />
      </Table.Td>
    </Table.Tr>
  );
};
